// removed by extract-text-webpack-plugin
module.exports = {"Container":"contact__Container__1FUY6","BackgroundContainer":"contact__BackgroundContainer__3LmnB","Background":"contact__Background__3tD4l","Tagline":"contact__Tagline__1RCpT","Banner":"contact__Banner__w3JD4","Sup":"contact__Sup__FAvLs","Image":"contact__Image__2CIoX","Content":"contact__Content__3E6Rs","Description":"contact__Description__3gx7L","Link":"contact__Link__YKqjX","Links":"contact__Links__2bsyA contact__Link__YKqjX"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Contact/contact.css
// module id = 1255
// module chunks = 2